import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map, Observable } from 'rxjs';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { DialogData } from './model/dialog/dialog-data';
import { DialogResult } from './model/dialog/dialog-result';
import { Ordem } from '../model/ordem';
import { Router } from '@angular/router';
import { UserDataService } from './user-data.service';

@Injectable({ providedIn: 'root' })
export class DialogService {
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private userDataService: UserDataService
  ) {}

  public showDialog(data: DialogData, width = 'auto'): Observable<DialogResult> {
    const dialogRef = this.dialog.open(DialogComponent, {
      width,
      maxWidth: '690px',
      data,
      disableClose: true
    });
    return dialogRef.afterClosed();
  }

  public showAlert(messages: string[], confirmText = 'Entendi', width = '470px'): Observable<void> {
    const data: DialogData = { messages, confirmText, showCancel: false };
    return this.showDialog(data, width).pipe(map(() => {}));
  }

  public showConfirmation(messages: string[], confirmText = 'Sim', cancelText = 'Não', width = '490px'): Observable<boolean> {
    const data: DialogData = { messages, confirmText, cancelText };
    return this.showDialog(data, width).pipe(map(result => result?.confirm));
  }

  public showOrdemEmAtendimentoDialog(ordem: Ordem): void {
    var dialogData: DialogData;
    var isMesmoSolicitante = false;
    if (ordem.orgao === null) {
      dialogData = this.getMensagemOrgaoNull();
    } else {
      isMesmoSolicitante = this.userDataService.userData.getValue().orgao.id === ordem.orgao.id;
      dialogData = this.getMesagemOrgaoExistente(isMesmoSolicitante, ordem);
    }

    this.showDialog(dialogData).subscribe(result => {
      if (isMesmoSolicitante && !result.confirm) {
        this.router.navigate(["listar-ordem", ordem.numeroProcesso]);
      }
    });
  }

  private getMensagemOrgaoNull(): DialogData {
    return {
      messages: [
        `Existe uma ordem em atendimento vinculada a este processo, enviada por outra Unidade Judiciária. Para novo envio, aguarde a finalização da solicitação.`
      ],
      confirmText: 'Entendi',
      showCancel: false
    };
  }

  private getMesagemOrgaoExistente(isMesmoSolicitante: boolean, ordem: Ordem): DialogData {
    return isMesmoSolicitante
      ? {
          messages: ['Existe outra ordem em atendimento, por favor, aguarde a finalização.'],
          confirmText: 'Entendi',
          cancelText: 'Ver ordem'
        }
      : {
          messages: [
            `Existe uma ordem em atendimento vinculada a este processo, enviada pela Unidade Judiciária <strong>${ordem.orgao.nome}</strong>. Para novo envio, aguarde a finalização da solicitação.`
          ],
          confirmText: 'Entendi',
          showCancel: false
        };
  }

}

